import React from "react";
import ReactDOM from "react-dom";

//Components
import App from "./App";

ReactDOM.render(<App />, document.getElementById("root"));
